import { gql } from "@apollo/client";

export const createNewTag = gql`
    mutation CreateTag($name: String!, $entityType: String) {
        createTag(createTagInput: { name: $name, entityType: $entityType }) {
            id
            name
        }
    }
`;
